"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { SidebarTrigger } from "@workspace/ui/components/sidebar";
import { cn } from "@workspace/ui/lib/utils";

/** `className` lets a page restyle the bar to suit itself. */
export function PublicHeader({ className }: { className?: string }) {
  const pathname = usePathname() ?? "";

  const links = [
    { label: "Links", href: "/links" },
    { label: "Blog", href: "/blog" },
    { label: "Bookshelf", href: "/bookshelf" },
  ];

  const isActive = (href: string) => pathname === href || pathname.startsWith(`${href}/`);

  return (
    <header
      className={cn(
        "sticky top-0 z-40 w-full border-b bg-background/80 text-foreground backdrop-blur supports-[backdrop-filter]:bg-background/60",
        className,
      )}
    >
      <div className="public-width flex h-12 items-center justify-between px-3 sm:px-4">
        <div className="flex items-center gap-3">
          <SidebarTrigger className="-ml-1 md:hidden" />
          <Link href="/links" className="font-semibold tracking-tight">subhan.io</Link>
        </div>
        <nav className="hidden md:flex items-center gap-6 text-sm">
          {links.map((l) => (
            <Link
              key={l.href}
              href={l.href}
              className={cn(
                "transition-opacity hover:opacity-80",
                isActive(l.href) ? "opacity-100" : "opacity-60"
              )}
              aria-current={isActive(l.href) ? "page" : undefined}
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
